import { required, maxLength, helpers, requiredIf } from '@vuelidate/validators';
import i18n from "@/plugins/i18n";

// Match by method name returned from the GET endpoint (field: payment_method)
const isBankTransfer = (form) => (form.method_name || '').toLowerCase().includes('bank');
const isQRCode = (form) => (form.method_name || '').toLowerCase().includes('qr');

export default function (formState) {
  return {
    form: {
      bank_name: {
        required: helpers.withMessage(
          i18n.global.t('Please enter bank name.'),
          requiredIf(isBankTransfer(formState))
        ),
        maxLength: helpers.withMessage(
          ({ $params }) => i18n.global.t('Bank name cannot exceed') + ' ' + $params.max + ' ' + i18n.global.t('characters.'),
          maxLength(100)
        )
      },
      account_no: {
        required: helpers.withMessage(
          i18n.global.t('Please enter account number.'),
          requiredIf(isBankTransfer(formState))
        ),
        maxLength: helpers.withMessage(
          ({ $params }) => i18n.global.t('Account number cannot exceed') + ' ' + $params.max + ' ' + i18n.global.t('characters.'),
          maxLength(50)
        )
      },
      account_name: {
        required: helpers.withMessage(
          i18n.global.t('Please enter account name.'),
          requiredIf(isBankTransfer(formState) || isQRCode(formState))
        ),
        maxLength: helpers.withMessage(
          ({ $params }) => i18n.global.t('Account name cannot exceed') + ' ' + $params.max + ' ' + i18n.global.t('characters.'),
          maxLength(100)
        )
      },
      promptpay_no: {
        required: helpers.withMessage(
          i18n.global.t('Please enter PromptPay number.'),
          requiredIf(isQRCode(formState))
        ),
        maxLength: helpers.withMessage(
          ({ $params }) => i18n.global.t('PromptPay number cannot exceed') + ' ' + $params.max + ' ' + i18n.global.t('characters.'),
          maxLength(50)
        )
      },
      active: {
        required: helpers.withMessage(i18n.global.t('Please enter.'), required)
      }
    }
  }
};
